import React from 'react';
import Carousel from './components/Carousel/Carousel';

function App() {
    return (
        <div className="app">
            <Carousel />
        </div>
    );
}

export default App;
